((app, ng) => {

    app.config($stateProvider => {
        $stateProvider.state("Home.Client.Case",
            {
                url: "/Case/{caseId}",
                component: "case",
                resolve: {
                    clientCase: (caseApi, $stateParams) => {
                        return caseApi.getCase($stateParams.caseId);
                    }
                }
            });
    });

    app.component("case",
        {
            templateUrl: "/App/Client/Case/case.html",
            controller: caseController,
            bindings: {
                clientCase: "<",
                currentUser: "<",
                client: "<"
            }
        });

    function caseController(caseApi, advisorApi, caseModalService, $state) {
        const $ctrl = this;

        this.$onInit = function () {
            $ctrl.accounts = [];
            $ctrl.cases = [];
            $ctrl.advisors = [];
            $ctrl.ui = {
                loading: false,
            };

            caseApi.getCases($ctrl.client.Id).then(response => {
                $ctrl.cases = response;
            });

            advisorApi.getAdvisors().then(response => {
                $ctrl.advisors = response;
            });
        }

        const updateCase = (clientCase) => {
            caseApi.updateCase(clientCase.Id, clientCase); 
        }

        const deleteCase = ({ Id, Name }, $event) => {
            caseModalService.confirmCaseDeletion(Name, $event).then(() => {
                $ctrl.ui.loading = true;

                caseApi.deleteCase(Id).then(() => {
                    $state.go("Home.Client.Cases", {}, { reload: true });
                });
            });
        }

        const goToCase = (caseId) => {
            if (!!caseId) {
                $state.go("Home.Client.Case", { caseId }, { reload: true });
            }
        }

        ng.extend($ctrl,
            {
                updateCase,
                deleteCase,
                goToCase,
            });
    }

})(window.app, window.angular);